<template>
  <div class="bill-pay-login__main gds-flex-container">
    <div class="bill-pay-login__login-type-container">
      <section id="top-target" class="bill-pay-login__account-select">
        <h2 class="gds-display-1">Choose Account</h2>

        <form class="bill-pay-login__form" @submit.prevent>
          <fieldset class="gds-fieldset">
            <legend class="gds-body-normal gds-space-stack-ml">To stop service, please select the account from the list below.</legend>
            <label v-for="account in accounts" :key="account.accountNumber" class="bill-pay-login__form--radio-label-flex gds-radio">
              <input v-model="selectedAccountNumber" type="radio" :value="account.accountNumber" />
              <span class="gds-radio__faux"></span>
              <span class="gds-radio__label bill-pay-login__radio-label">
                <span v-if="account.nickname">
                  <b>{{account.nickname}}</b>
                  <br />
                </span>
                {{account.address | addressFormat({ separator: ", " })}}
                <br />
                Acct #: {{account.accountNumber}}
              </span>
            </label>
          </fieldset>
        </form>

        <div class="gds-space-stack-l">
          <button @click="ReturnToSender('/stop-service')" type="button" class="gds-button gds-secondary gds-space-inline-m">Cancel</button>
          <button @click="nextPage()" class="gds-button gds-space-inline-m">Next</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { DumpError, ReturnToSender } from "../../utilities";

export default {
  name: "StopServiceAccount",
  data() {
    return {
      ReturnToSender,
      selectedAccountNumber: undefined,
    };
  },
  computed: {
    isAdmin() {
      return !!this.$store.state.user.userinfo.isAdmin;
    },
    accounts() {
      if (!this.isAdmin) {
        return this.$store.state.user.accounts;
      } else {
        return this.$store.state.user.ghostAccounts || [];
      }
    },
  },
  async mounted() {
    try {
      if (this.accounts.length === 1) {
        this.$store.commit("setCurrentAccount", this.accounts[0]);
        this.$router.push({ path: "/stop/1" });
      } else {
        if (!this.selectedAccountNumber) {
          let current = this.accounts.find(item => item.accountNumber === this.$store.state.user.currentAccount.accountNumber);
          if (!current) {
            current = this.accounts.find(item => item.isPrimary);
          }
          if (!current) {
            current = this.accounts[0];
          }
          this.selectedAccountNumber = current.accountNumber;
        }
      }
    } catch (err) {
      DumpError("Account mount error", err);
    }
  },
  methods: {
    async nextPage() {
      try {
        let selected = this.accounts.find(item => item.accountNumber === this.selectedAccountNumber);
        this.$store.commit("setCurrentAccount", selected);
        this.$router.push({ path: "/stop/1" });
      } catch (err) {
        DumpError("Account next error", err);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>